import { Preferences } from '@capacitor/preferences';

import {APIError} from 'helpers/Rest';
import ServerActions from 'actions/ServerActions';

export const login = (username, password) => async (dispatch, _getState, {api}) => {
  const {access_token:token} = await api.getAuthToken(username, password);
  if (!token) return;

  dispatch(ServerActions.receivedAccessToken(token, username));
  await api.initializeAppData();

  if (window.device.platform == 'ios') {
    api.requestAppTrackingTransparency();
  }
};

export const logout = () => (dispatch) => {
  Preferences.clear();
  return dispatch({type: 'LOGOUT'});
};

const AuthenticationActions = {login, logout}

global.logout = logout;

export default AuthenticationActions;
